import { useEffect, useState } from 'react';
import { getSDK } from '../services/sdk-instance';

export type QueuedImageThumbnail =
  | { state: 'loading' }
  | { state: 'missing' }
  | { state: 'error'; message: string }
  | { state: 'ready'; url: string };

// (sdk ADR-b0123)
export function useQueuedImageThumbnail(sessionId: string | undefined, imageId: string): QueuedImageThumbnail {
  const [thumb, setThumb] = useState<QueuedImageThumbnail>({ state: 'loading' });
  useEffect(() => {
    setThumb({ state: 'loading' });
    if (!sessionId) return;
    let url: string | null = null;
    let cancelled = false;
    void getSDK()
      .chat.queuedImages.get(sessionId, imageId)
      .then(
        (blob) => {
          if (cancelled) return;
          if (!blob) {
            setThumb({ state: 'missing' });
            return;
          }
          url = URL.createObjectURL(blob);
          setThumb({ state: 'ready', url });
        },
        (err: unknown) => {
          if (cancelled) return;
          console.error('queued-image store read failed', err);
          setThumb({ state: 'error', message: err instanceof Error ? err.message : String(err) });
        },
      );
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [sessionId, imageId]);
  return thumb;
}
